// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1eaa6faf","136":"0b02177d","534":"82b756da","859":"391ae0fd"}[chunkId] + ".chunk.js";
};